import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-box-arrow",
  "use": "icon-box-arrow-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-box-arrow\"><path d=\"M21 7V1m0 0h-6m6 0L8 14m13-2v9H1V1h9\" stroke=\"currentColor\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol